<template>
  <v-col class="pa-0">
    <v-list
      dense
    >
      <v-list-item-group
        color="blue"
        multiple
        :value="selectedIndices"
      >
        <v-list-item
          v-for="item in filterOptions"
          :key="item.slug"
          @click="addFilter(item.slug)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.label" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-row>
      <v-col cols="6">
        <v-btn
          v-if="selectedValues.length"
          color="red"
          @click="doRemoveFilter"
        >
          {{ $t('clear') }}
        </v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn
          v-if="selectedValues.length"
          color="blue"
          @click="doSetFilter"
        >
          {{ $t('save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
  import _ from 'lodash'

  export default {
    props: {
      filterName: {
        type: String,
        default: '',
      },
      filterOptions: {
        type: Array,
        default: () => [],
      },
      selectedValues: {
        type: Array,
        default: () => [],
      },
      setFilter: {
        type: Function,
        default: (from, to) => console.log(from, to),
      },
    },
    data () {
      return {
        selected: [],
      }
    },
    computed: {
      selectedIndices: function () {
        const returnArray = []
        _.each(this.selected, sv => {
          returnArray.push(_.findIndex(this.filterOptions, { slug: sv }))
        },
        )

        return returnArray
      },
    },
    mounted: function () {
      this.selected = this.selectedValues
    },
    methods: {
      addFilter: function (option) {
        const i = _.indexOf(this.selected, option)
        if (i > -1) this.selected.splice(i, 1)
        else {
          this.selected.push(option)
        }
      },
      doSetFilter: function () {
        this.$emit('filter-added', {
          [this.filterName]: this.selected,
        })
      },
      doRemoveFilter: function () {
        this.selected = []
        this.$emit('filter-remove', this.filterName)
      },
    },
  }
</script>
